import React, { useState } from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'

// Pill-style trigger that opens a popover of selectable options. Same public
// API as before: `options` ([{value, name}] or scalars), `value`, `onChange`,
// `placeholder`, `displayMap`, `numeric`, `icon` (a lucide component),
// `footer`.
const PillSelect = ({ options, value, onChange, placeholder, displayMap, numeric, icon: Icon, footer }) => {
  const [open, setOpen] = useState(false)

  const selected = _.find(options, (o) => {
    const optVal = typeof o === 'object' ? o.value : o
    return String(optVal) === String(value)
  })

  let displayValue = null
  if (selected) {
    const selectedVal = typeof selected === 'object' ? selected.value : selected
    const selectedName = typeof selected === 'object' ? selected.name : selected
    displayValue = displayMap && displayMap[String(selectedVal)] ? displayMap[String(selectedVal)] : selectedName
  }

  const onSelect = (optVal) => {
    onChange(optVal)
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        className={
          'inline-flex h-9 select-none items-center gap-2 whitespace-nowrap rounded-lg border bg-background px-3.5 text-[13.5px] font-medium text-foreground transition-colors hover:bg-muted ' +
          (displayValue ? 'border-border' : 'border-dashed border-border text-muted-foreground')
        }
      >
        {Icon && <Icon className="size-3.5 text-muted-foreground" />}
        <span>{displayValue || placeholder || 'Select'}</span>
        <ChevronDown className="size-3.5 text-muted-foreground" />
      </PopoverTrigger>
      <PopoverContent align="center" className="w-max max-w-[550px]">
        <div className="flex flex-wrap gap-2">
          {_.map(options, (opt) => {
            const optVal = typeof opt === 'object' ? opt.value : opt
            const optName = typeof opt === 'object' ? opt.name : opt
            const isSelected = String(value) === String(optVal)

            return (
              <button
                key={optVal}
                type="button"
                onClick={() => onSelect(optVal)}
                className={cn(
                  'whitespace-nowrap rounded-lg border text-sm font-medium transition-colors',
                  numeric ? 'flex size-10 items-center justify-center' : 'px-3.5 py-2',
                  isSelected
                    ? 'border-primary bg-primary text-primary-foreground'
                    : 'border-border bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground'
                )}
              >
                {optName}
              </button>
            )
          })}
        </div>
        {footer && <div className="mt-2">{footer}</div>}
      </PopoverContent>
    </Popover>
  )
}

export default PillSelect
